import React, { useCallback, useReducer, useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { PageHeader, /*SmallInput,*/ LineReducer, Button, LineSetContext, LineUI } from 'scorer-ui-kit';
import { Container, Buttons, HeaderContainer, BackButton, ValidationAlert, LineUIContainer, LineUiImageWrapper, NoImage } from '../../style';
import { useTranslation } from 'react-i18next';
import { MenuContext, PathContext } from '../../App';
import useLocalStorage from '../../hooks/useLocalstorage';
import noImg from '../../images/noimg.png';
import { SNAPSHOT_API_URL } from '../../utils/Constants';

/*const InputContainer = styled.div`
  display: flex;
  width: inherit;
  margin: 5px 0 0 0;
  height: 102px;
`;*/

/*const AreaInfo = styled.div`
  display: flex;
  flex-direction: column;
  width: auto;
  margin: 0 0 10px 0;
`;*/

/*const SelectFieldBox = styled.select`
  width: 104px;
  height: 30px;
  padding: 0 0 0 10px;
  border-radius: 3px;
  outline: none;
  font-family: ${({ theme }) => theme.fontFamily.ui};
  font-size: 14px;
  color: #767676;
  margin-top: 5px;
`;*/

/*const Position = styled.div`
  display: flex;
  flex-direction: column;
  width: auto;
  margin: 0 0 10px 0;
`;*/

/*const SmallInputContainer = styled.div`
  display: flex;
  width: auto;
  margin: 0 30px 0 0; 
`;*/

/*const SmallInputBox = styled(SmallInput)`
  width: 104px;
  padding: 0 14px 0 0;
  border-radius: 3px;
  outline: none;
  font-family: ${({ theme }) => theme.fontFamily.ui};
  font-size: 12px;
  color: #767676;
  margin-top: -5px;
`;*/

/*const InputHeader = styled.label`
  font-family: ${({ theme }) => theme.fontFamily.ui};
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.35px;
  color: #7f7f7f;
  margin-bottom: 7px;
`;*/

/*const InputField = styled.div`
  display: flex;
  flex-direction: column;
`;*/


const LineUIWrapper = styled(LineUIContainer)`
  margin-bottom: 30px;
`;

const LineUIImageContainer = styled(LineUiImageWrapper)`
  margin-left: -30px;
  padding: 20px 30px;
`;



const SetupFloorplan = () => {
  const [ imgsrc, setImgsrc ] = useState(SNAPSHOT_API_URL + '?p=' + new Date().getTime());
  const { t } = useTranslation(['SetupFloorplan', 'Common']);
  const [validationAlert/*, setValidationAlert*/] = useState<Alert>({ key: new Date(), message: '', type: 'error' });

  const { completedStep, setSelectedStep, setCompletedStep } = useContext(MenuContext);
  const { pathUpdated } = useContext(PathContext);

  const { floorPlanStorage, setFloorPlanStorage } = useLocalStorage();

  const [state, dispatch] = useReducer(LineReducer, []);
  const [poseAreas, setPoseAreas] = useState(floorPlanStorage.PoseAreas ? floorPlanStorage.PoseAreas : []);  
  //const [selectedAreaName, setSelectedAreaName] = useState('');

  useEffect(() => {
    setInterval(() => {
      setImgsrc(SNAPSHOT_API_URL + '?p=' + new Date().getTime());
    }, 3000);
  }, []);


  /*--------エリア設定--------*/
  //エリア初期化
  useEffect(() => {
    if ( floorPlanStorage.PoseAreas.length !== 0 ){
      //setSelectedAreaName(floorPlanStorage.PoseAreas[0].data.name);
      const data = [];
      for (const i in floorPlanStorage.PoseAreas){
        data.push(floorPlanStorage.PoseAreas[i].data);
      }
      dispatch({
        type: 'LOAD',
        state: data
      });

    }else{
      //setSelectedAreaName('PoseArea0');
      const data = {
        name: 'PoseArea0',
        points: [
          {'x': 0, 'y': 0},
          {'x': 1280, 'y': 0},
          {'x': 1280, 'y': 720},
          {'x': 0, 'y': 720}
        ]
      };
      dispatch({
        type: 'ADD_SET',
        data 
      });
      setPoseAreas([{'id': 0, 'data': data}]);
    }
  }, [floorPlanStorage.PoseAreas, setPoseAreas, setCompletedStep]);

  //エリア追加
  /*const addArea = useCallback( () => {
    // LineReducerには何故かid項目がないため、面倒ください
    let newid = poseAreas.length;
    const newPoseAreas = [];
    const idList = [];
    for(let i = 0; i < poseAreas.length; i++) {//既存job id取得
      idList.push(poseAreas[i].id);
      newPoseAreas.push({'id': poseAreas[i].id, 'data': poseAreas[i].data});
    }
    for(let i = 0; i < idList.length; i++) {
      if (idList.indexOf(i) === -1){
        newid = i;
        break;
      }
    }

    const data = {
      name: 'PoseArea' + newid,
      points: [
        {'x': 0, 'y': 0},
        {'x': 300, 'y': 0},
        {'x': 300, 'y': 200},
        {'x': 0, 'y': 200}
      ]
    };
    dispatch({
      type: 'ADD_SET',
      data
    });
    newPoseAreas.push({'id': newid, 'data': data});
    setPoseAreas(newPoseAreas);
    setSelectedAreaName('PoseArea' + newid);
  }, [poseAreas]);*/

  //エリア削除
  /*const removeArea = useCallback( () => {
    if (state.length <= 1) return false;
    // id削除
    for(const i in poseAreas){
      if(poseAreas[i].data.name === selectedAreaName) {
        poseAreas.splice(Number(i), 1);
      }
    }

    // LineReducer state 削除
    for(const i in state){
      if(state[i].name === selectedAreaName) {
        const index = Number(i);
        dispatch({
          type: 'REMOVE_SET',
          index
        });
        if(index === 0) setSelectedAreaName((state[1].name));
        else setSelectedAreaName((state[0].name));
        break;
      }
    }
  }, [state, poseAreas, selectedAreaName]);*/

  //エリア名変更
  /*const renameArea = useCallback(({ target: { value } }) => {
    for(const i in poseAreas){
      if(poseAreas[i].data.name === selectedAreaName) {
        poseAreas[i].data.name = value;
      }
    }

    for(const i in state){
      if(state[i].name === selectedAreaName) {
        state[i].name = value;
        setSelectedAreaName(value);
        dispatch({
          type: 'LOAD',
          state
        });
        break;
      }
    }
  }, [state, poseAreas, selectedAreaName]);

  const addPoint = useCallback(() => {
    for(const i in state){
      if(state[i].name === selectedAreaName) {
        const index = Number(i);
        dispatch({
          type: 'ADD_POINT',
          index
        });
        break;
      }
    }
  },[state, selectedAreaName]);

  const removePoint = useCallback(() => {
    for(const i in state){
      if(state[i].name === selectedAreaName) {
        if(state[i].points.length <= 3) return;
        const index = Number(i);
        dispatch({
          type: 'REMOVE_POINT',
          index
        });
        break;
      }
    }
  },[state, selectedAreaName]);*/
  /*--------エリア設定--------*/

  /*const getSelectedArea = useCallback((ev) => {
    for(const i in state){
      if(state[i].name === ev.target.value) {
        setSelectedAreaName(ev.target.value);
        break;
      }
    }
  }, [state]);*/


  /*---------route---------*/  
  const onContinue = useCallback((index: number) => {
    // 最新のLineReducer stateを記録
    const newPoseAreas = [];
    for(let i = 0; i < poseAreas.length; i++) {
      for(let k = 0; k < state.length; k++) {
        if (poseAreas[i].data.name === state[k].name){
          newPoseAreas.push({'id': poseAreas[i].id, 'data': state[k]});
        }
      }
    }

    setSelectedStep(index);
    setFloorPlanStorage({PoseAreas: newPoseAreas});
    setFloorPlanStorage({completed_step: 11});
    setFloorPlanStorage({selected_step: index});
    setCompletedStep(completedStep > 11 ? completedStep : 11);
  }, [state, poseAreas, completedStep, setCompletedStep, setSelectedStep, setFloorPlanStorage]);

  useEffect(() => {
    if (pathUpdated) { setSelectedStep(11); }
  }, [setSelectedStep, pathUpdated]);
  /*---------route---------*/
  return (
    <Container>
      <HeaderContainer>
        <PageHeader title='作業判定エリア設定' areaHref='/' areaTitle={floorPlanStorage.completed_step === 999 ? '初期設定': '設定編集'} />
        <Buttons>
          <BackButton size='small' design='secondary' onClick={() => onContinue(10)}>{t('Common:back')}</BackButton>
          <Button design='primary' size='small' onClick={() => onContinue(12)}>{t('Common:next')}</Button>
        </Buttons>
      </HeaderContainer>

      {validationAlert.message !== '' &&
        <ValidationAlert type={validationAlert.type} message={validationAlert.message} />}

      {imgsrc ?
        <>
          {/*<InputContainer>
            <AreaInfo>
              <InputHeader>判定エリア設定</InputHeader>
              <SmallInputContainer>
                <InputField>
                  <Button design='primary' size='small' onClick={addArea}>add</Button>
                </InputField>
              </SmallInputContainer>
            </AreaInfo>

            <AreaInfo>
              <InputHeader>編集エリア選択</InputHeader>
              <SmallInputContainer>
                <InputField>
                  <SelectFieldBox value={selectedAreaName} onChange={getSelectedArea}>
                    {state.map((item: any) => {
                      return <option key={item.name} value={item.name}>{item.name}</option>;
                    })}
                  </SelectFieldBox>
                </InputField>
              </SmallInputContainer>
            </AreaInfo>

            <Position>
              <InputHeader>エリア名</InputHeader>
              <SmallInputContainer>                
                <InputField>
                  <SmallInputBox label='' value={selectedAreaName} onChange={renameArea} />
                </InputField>
              </SmallInputContainer>
            </Position>

            <Position>
              <InputHeader>頂点数設定</InputHeader>
              <SmallInputContainer>
                <InputField>
                  <Button size='small' design='primary' onClick={removePoint}>－</Button>
                </InputField>
                <InputField>
                  <Button size='small' design='primary' onClick={addPoint}>＋</Button>
                </InputField>
              </SmallInputContainer>
            </Position>
            
            <AreaInfo>
              <InputHeader>エリア削除</InputHeader>
              <SmallInputContainer>
                <InputField>
                  <Button size='small' design='primary' onClick={removeArea}>remove</Button>
                </InputField>
              </SmallInputContainer>
            </AreaInfo>
            

          </InputContainer>*/}

          <LineUIImageContainer height={window.innerHeight - 340} id='camera-position-img' isScrollbar={false}>
            <LineSetContext.Provider value={{ state, dispatch }}>
              <LineUIWrapper className='shadow'>
                <LineUI src={imgsrc} />
              </LineUIWrapper>
            </LineSetContext.Provider>
          </LineUIImageContainer>
        </> :
        <NoImage src={noImg} />}
    </Container>
  );
};

export default SetupFloorplan;
